// Local translations
export const T = {
  en_GB: {
    xrayNoAccess:
      "Your tenant does not have access to Morningstar X-Ray features. Contact Quantfolio to enable this feature.",
    displayMode: "Display Mode",
    assetAllocation: "Asset Allocation",
    countryExposure: "Country Exposure (Top 10)",
    regionalExposure: "Regional Exposure",
    stockSector: "Stock Sector",
    equityStyleBox: "Equity Style Box",
    bondSector: "Bond Sector",
    topHoldings: "Top 10 Holdings",
    xrayDisplayModeHelp: "Choose which data to display from the X-Ray analysis",
    showChart: "Show Chart",
    showChartDesc: "Display the pie chart visualization",
    showTable: "Show Table",
    showTableDesc: "Display data table with color indicators",
    enableFollowupComparison: "Enable comparison in follow up sessions",
    enableFollowupComparisonDesc:
      "Show existing vs modified portfolio side-by-side when the session is a followup",
    atLeastOneOption: "At least one display option must be selected",
    required: "*",
  },
  nb_NO: {
    xrayNoAccess:
      "Din organisasjon har ikke tilgang til Morningstar X-Ray-funksjoner. Kontakt Quantfolio for å aktivere denne funksjonen.",
    displayMode: "Visningsmodus",
    assetAllocation: "Aktivaallokering",
    countryExposure: "Landseksponering (Topp 10)",
    regionalExposure: "Regional eksponering",
    stockSector: "Aksjesektor",
    equityStyleBox: "Aksjestilboks",
    bondSector: "Obligasjonssektor",
    topHoldings: "Topp 10 beholdninger",
    xrayDisplayModeHelp: "Velg hvilke data som skal vises fra X-Ray-analysen",
    showChart: "Vis diagram",
    showChartDesc: "Vis sektordiagramvisualisering",
    showTable: "Vis tabell",
    showTableDesc: "Vis datatabell med fargeindikatorer",
    enableFollowupComparison: "Aktiver sammenligning i oppfølgingsøkter",
    enableFollowupComparisonDesc:
      "Vis eksisterende og endret portefølje side om side når økten er en oppfølging",
    atLeastOneOption: "Minst ett visningsalternativ må være valgt",
    required: "*",
  },
} as const;
